<script setup>
import {
  onMounted,
  ref,
} from 'vue';
import throttle from '@/utils/throttle';
import { isDevServer } from '@/config';
import { useI18n } from 'vue-i18n';

const state = ref(false);
const version = ref('');
const { t } = useI18n();
let interval;
let throttleCheckVersion;

const INDEX_JS_REGEX = /index-[\w\d_-]+\.js/;

const getJavascriptHash = async () => {
  let hash;

  try {
    const headers = new Headers();
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');

    const response = await fetch('/index.html', { method: 'GET', headers });
    const html = await response.text();
    const [fileName] = html.match(INDEX_JS_REGEX);

    hash = fileName.replace(/index-/, '').replace(/.js/, '');
  } catch (error) {
    // console.error(error);
    return null;
  }
  return hash;
};

const checkVersion = async () => {
  const v = await getJavascriptHash();

  if (!v) {
    return;
  }

  if (v !== version.value) {
    state.value = true;

    clearInterval(interval);
    document.removeEventListener('visibilitychange', throttleCheckVersion);
  }
};

throttleCheckVersion = throttle(checkVersion, 5000);

const init = async () => {
  if (isDevServer) {
    return;
  }

  try {
    const scripts = [...document.head.querySelectorAll('script')].map((elm) => elm.outerHTML);
    const [fileName] = scripts.join('').match(INDEX_JS_REGEX);

    version.value = fileName.replace(/index-/, '').replace(/.js/, '');
  } catch (error) {
    // console.error(error);
  }

  interval = setInterval(interval, 1000 * 60 * 5);

  document.addEventListener('visibilitychange', throttleCheckVersion, false);
};

onMounted(() => {
  init();
});

const reload = () => {
  window.location.reload();
};

</script>
<template>
  <div class="system-pop" v-if="state">
    <div class="system-pop__head">
      <h5>
        {{ t('versionPanel.title') }}
        <span class="version">{{ version }}</span>
      </h5>
      <v-btn
        class="refresh__button"
        prepend-icon="mdi-refresh"
        @click="reload"
      >
        {{ t('versionPanel.button') }}
      </v-btn>
    </div>
    <div class="system-pop__body">
      <p>{{ t('versionPanel.content') }}</p>
    </div>
  </div>
</template>
